var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCourseBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 328,
    height: 381,
    viewBox: "0 0 328 381",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_441_2",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 328,
    height: 381
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.4375,
    width: 328,
    height: 380,
    rx: 8,
    fill: "#222222"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_441_2)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26.7485,
    y: 38.9087,
    width: 274.755,
    height: 274.755,
    transform: "rotate(0.0576591 26.7485 38.9087)",
    stroke: "url(#paint0_linear_441_2)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46.2192,
    y: 61.2202,
    width: 235.361,
    height: 235.361,
    transform: "rotate(0.0576591 46.2192 61.2202)",
    stroke: "url(#paint1_linear_441_2)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65.688,
    y: 83.5318,
    width: 195.968,
    height: 195.968,
    transform: "rotate(0.0576591 65.688 83.5318)",
    stroke: "url(#paint2_linear_441_2)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.1538,
    y: 105.847,
    width: 156.574,
    height: 156.574,
    transform: "rotate(0.0576591 85.1538 105.847)",
    stroke: "url(#paint3_linear_441_2)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.622,
    y: 128.159,
    width: 117.181,
    height: 117.181,
    transform: "rotate(0.0576591 104.622 128.159)",
    stroke: "url(#paint4_linear_441_2)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124.092,
    y: 150.47,
    width: 77.7872,
    height: 77.7872,
    transform: "rotate(0.0576591 124.092 150.47)",
    stroke: "url(#paint5_linear_441_2)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_441_2",
    x1: 164.127,
    y1: 38.4082,
    x2: 164.127,
    y2: 314.163,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDE9D",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.316666,
    stopColor: "#CF0175"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.613541,
    stopColor: "#13DEA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0A818"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_441_2",
    x1: 163.9,
    y1: 60.7197,
    x2: 163.9,
    y2: 297.081,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDE9D",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.316666,
    stopColor: "#CF0175"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.613541,
    stopColor: "#13DEA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0A818"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_441_2",
    x1: 163.672,
    y1: 83.0312,
    x2: 163.672,
    y2: 279.999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDE9D",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.316666,
    stopColor: "#CF0175"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.613541,
    stopColor: "#13DEA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0A818"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_441_2",
    x1: 163.441,
    y1: 105.347,
    x2: 163.441,
    y2: 262.921,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDE9D",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.316666,
    stopColor: "#CF0175"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.613541,
    stopColor: "#13DEA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0A818"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_441_2",
    x1: 163.212,
    y1: 127.658,
    x2: 163.212,
    y2: 245.839,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDE9D",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.316666,
    stopColor: "#CF0175"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.613541,
    stopColor: "#13DEA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0A818"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_441_2",
    x1: 162.986,
    y1: 149.97,
    x2: 162.986,
    y2: 228.757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDE9D",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.316666,
    stopColor: "#CF0175"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.613541,
    stopColor: "#13DEA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0A818"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCourseBg);
export default __webpack_public_path__ + "static/media/CourseBG.eec9a63b3796a32b431c8db8559dcab9.svg";
export { ForwardRef as ReactComponent };